import { BaseEntity } from './base.entity';
import { PatchesEntity } from './patches.entity';

export interface BaseHistoryEntity extends BaseEntity {
  history?: PatchesEntity[];
}
